import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { InitService } from '@infodata-group/inf-commons';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Meta } from '@angular/platform-browser';
import {
  PageLoginMobileComponent,
  PagePwdResetMobileComponent,
  PageResetRequestMobileComponent,
} from '@infodata-group/inf-commons-mobile';
import { environment } from '../../environments/environment';

const appInitFactory = () => {
  const initService = inject(InitService);
  const router = inject(Router);
  const deviceService = inject(DeviceDetectorService);
  const meta = inject(Meta);

  if (deviceService.isMobile()) {
    const routes = router.config
      .filter(
        (r) => ['login', 'reset-request', 'reset-password'].indexOf(r.path) < 0,
      )
      .concat([
        { path: 'login', component: PageLoginMobileComponent },
        { path: 'reset-request', component: PageResetRequestMobileComponent },
        { path: 'reset-password', component: PagePwdResetMobileComponent },
      ]);
    router.resetConfig(routes);
    meta.updateTag({ name: 'theme-color', content: '#FFF' });
  }
  initService.init(environment.env);
};

export const initProvider: EnvironmentProviders =
  provideEnvironmentInitializer(appInitFactory);
